'use client';

import isUrl from 'is-url';
import styled from 'styled-components';

import { LinkHelpers, type LinkElementType } from '@zoomit/editor';
import { Link } from '@zoomit/primitives';
import { theme } from '@zoomit/zoomit-ds';

import { useOrigin } from '../../../providers/OriginProvider';

interface RenderElementProps {
  children: any;
  element: LinkElementType;
  id?: string;
}

const LinkElement = (props: RenderElementProps) => {
  const { children, element } = props;
  const linkRel = LinkHelpers.generateLinkRel(element);
  const linkTarget = element.blankTarget ? '_blank' : undefined;
  const cleanedUri = element.url.replace(/\t$/, '');
  const cleanedInternalUri = cleanedUri.startsWith('/') ? cleanedUri : `/${cleanedUri}`;

  const { originUrl } = useOrigin();

  return (
    <LinkBase
      target={linkTarget}
      rel={linkRel}
      href={isUrl(encodeURI(cleanedUri)) ? cleanedUri : `${originUrl}${cleanedInternalUri}`}
    >
      {children}
    </LinkBase>
  );
};

const LinkBase = styled(Link)`
  color: var(${theme.primary2});
`;

export default LinkElement;
